(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sentopia-accords"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sentopia-accords')) {
    customElements.define('sentopia-accords', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const buttons = Array.from(this.querySelectorAll('[data-accord]'));
        const panels = Array.from(this.querySelectorAll('[data-panel]'));
        const select = (button) => {
          buttons.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
          panels.forEach(panel => { panel.hidden = panel.dataset.panel !== button.dataset.accord; });
        };
        this.addEventListener('click', event => {
          const button = event.target.closest('[data-accord]');
          if (button && this.contains(button)) select(button);
        });
        this.addEventListener('keydown', event => {
          const button = event.target.closest('[data-accord]');
          if (!button || !['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          let index = buttons.indexOf(button);
          if (event.key === 'ArrowDown') index = (index + 1) % buttons.length;
          if (event.key === 'ArrowUp') index = (index - 1 + buttons.length) % buttons.length;
          if (event.key === 'Home') index = 0;
          if (event.key === 'End') index = buttons.length - 1;
          buttons[index].focus();
          select(buttons[index]);
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
